module.exports = __webpack_public_path__ + "static/media/MLock User Guide v3.1.7.196f2bfb.pdf";